import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { PersonBadge } from '@gokrew/ui';
import { MyTeamDepth } from '@gokrew/models/my-team';
import { TranslationNS } from '@gokrew/models/constants';
import InfoCard from '@/components/InfoCard';
import { useMyTeamAccess, useMyTeamList } from '@/hooks/my-team/useMyTeam';
import { toBadgePerson } from '@/utils/my-team';
import { CardLoader } from '../CardLoader';
import styles from './TeamSnapshot.module.css';

export const TeamSnapshot = () => {
  const { t } = useTranslation(TranslationNS.MyTeam);
  const { data: access } = useMyTeamAccess();
  const team = useMyTeamList({ page: 1, limit: 4, depth: MyTeamDepth.Direct });
  if (!access?.enabled || !access.isManager) return null;
  return (
    <InfoCard
      className={styles.card}
      title={t('page.title')}
      action={
        <Link className={styles.link} to="/my-team">
          {t('to_approve.view_all')} <ArrowRight aria-hidden />
        </Link>
      }
    >
      {team.isLoading && <CardLoader />}
      {team.isError && (
        <p role="alert" className={styles.muted}>
          {t('state.error')}
        </p>
      )}
      {(team.data?.data ?? []).map((person) => (
        <Link
          key={person.employeeId}
          className={styles.person}
          to={`/my-team/members/${person.employeeId}`}
        >
          <PersonBadge
            person={toBadgePerson(person)}
            subtitle={person.designation?.name}
            size="sm"
          />
          <ArrowRight aria-hidden />
        </Link>
      ))}
      {!team.isLoading && !team.isError && !team.data?.data.length && (
        <p className={styles.muted}>{t('workspace.no_direct_reports')}</p>
      )}
    </InfoCard>
  );
};
